import React from "react";
import LegalPage from "../../components/legal-information/LegalPage";
import datenschutz from "../../content/datenschutz";

const Impressum = () => {
  return <LegalPage content={datenschutz} />;
};

export default Impressum;